import React, {useEffect, useState} from "react";

import "./FoundersGuideHeader.css";
import MagicFeedback from "@magicfeedback/native";

function FoundersGuideHeader() {
    const [loading, setLoading] = useState(true);
    // Initialize and render the MagicFeedback SDK
    useEffect(() => {
        MagicFeedback.init();

        // Best in class
        const contactForm = MagicFeedback.form(
            "e95b7390-d587-11ee-905b-03387063b532",
            "28f10ab552b1f6f33ddfc90f73e0238a"
        );

        contactForm.generate("magicfeedback-contact-container", {
            addButton: true,
            sendButtonText: "Book a demo",
            addSuccessScreen: true,
            questionFormat: "slim",
            onLoadedEvent: () =>
                setLoading(false),
            afterSubmitEvent: ({
                                   loading,
                                   progress,
                                   total,
                                   response, // Response of the server if everything is ok
                                   error, // Error of the server if something is wrong
                               }) => {
                if (error) {
                    // TODO: Show error message
                }

                //TODO: Show message of success
            },
        });

        //magicfeedback-success
    }, []);

    return (
        <main className="FoundersGuideHeader">
            <div className="founders-guide-header">
                <div className="founders-guide-container">
                    <div className="founders-guide-content-header">
                        <h2>Best in class user feedback best practices</h2>
                        <p>
                            Get the best practices from 10+ years of experience working with
                            user feedback across startups, scale-ups, and companies like
                            Google. Receive a free e-book with step-by-step guides and
                            examples.
                        </p>
                    </div>
                    <div className="magicfeedback">
                        {loading && <span className="loader"/>}
                        <div id="magicfeedback-contact-container">
                            {/** MagicFeedback SDK space */}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default FoundersGuideHeader;
